import { riskHero } from '@/mocks/riskManagementPage';

const toneStyles: Record<string, string> = {
  primary: 'bg-primary-100 text-primary-700',
  accent: 'bg-accent-100 text-accent-700',
  secondary: 'bg-secondary-100 text-secondary-900',
};

export default function Hero() {
  return (
    <section className="relative overflow-hidden border-b border-background-200 bg-background-50">
      <div className="pointer-events-none absolute inset-0 grid-lines opacity-40" />
      <div className="pointer-events-none absolute -right-24 -top-28 h-72 w-72 rounded-full bg-accent-100/50 blur-3xl" />
      <div className="pointer-events-none absolute -left-20 top-16 h-64 w-64 rounded-full bg-primary-100/50 blur-3xl" />

      <div className="relative mx-auto w-full max-w-7xl px-4 pb-9 pt-8 md:px-6 md:pb-11 md:pt-10 lg:px-10">
        <div className="grid grid-cols-1 gap-7 lg:grid-cols-[minmax(0,1.08fr)_minmax(0,0.92fr)] lg:gap-0">
          <div className="min-w-0">
            <span className="inline-flex items-center gap-2 rounded-full border border-primary-200 bg-background-50/80 px-3 py-1 text-[11px] font-semibold tracking-[0.1em] text-primary-700">
              <span className="h-1.5 w-1.5 rounded-full bg-accent-500" aria-hidden="true" />
              {riskHero.eyebrow}
            </span>

            <h1 className="mt-4 text-balance font-heading text-[27px] font-semibold leading-[1.18] text-foreground-950 sm:text-[33px] lg:text-[40px]">
              เรียนรู้การบริหารความเสี่ยง
              <span className="mt-1 block text-primary-700">ในการเทรด Forex</span>
            </h1>

            <p className="mt-4 flex flex-wrap items-center gap-x-3 gap-y-1 text-[11px] text-foreground-500">
              <span className="flex items-center gap-1.5 font-medium text-primary-700">
                <i className="ri-shield-check-line text-[13px]" aria-hidden="true" />
                วางแผนความเสี่ยงก่อนเปิดออเดอร์
              </span>
              <span className="h-3 w-px bg-background-300" aria-hidden="true" />
              <span>เนื้อหาภาษาไทยทั้งหมด</span>
            </p>
          </div>

          <div className="min-w-0 border-background-300/70 lg:border-l lg:pl-10">
            <p className="max-w-xl text-sm leading-relaxed text-foreground-700">
              {riskHero.description}
            </p>

            <div className="mt-5 flex flex-col gap-2.5 sm:flex-row sm:items-center sm:gap-3">
              <a
                href="#learning-path"
                className="group inline-flex cursor-pointer items-center justify-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
              >
                {riskHero.primaryCta}
                <i
                  className="ri-arrow-right-line text-sm transition-transform group-hover:translate-x-0.5"
                  aria-hidden="true"
                />
              </a>
              <a
                href="#tutorial-library"
                className="inline-flex cursor-pointer items-center justify-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-4 py-2.5 text-sm font-semibold text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
              >
                <i className="ri-bookmark-line text-sm" aria-hidden="true" />
                {riskHero.secondaryCta}
              </a>
            </div>
          </div>
        </div>

        <dl className="mt-7 grid grid-cols-1 gap-y-3 border-t border-background-300/70 pt-5 sm:grid-cols-3 sm:gap-y-0 sm:divide-x sm:divide-background-300/70">
          {riskHero.highlights.map((item, index) => (
            <div
              key={item.label}
              className={`flex items-center gap-3 sm:px-6 ${index === 0 ? 'sm:pl-0' : ''} ${
                index === riskHero.highlights.length - 1 ? 'sm:pr-0' : ''
              }`}
            >
              <span
                className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-md ${toneStyles[item.tone]}`}
                aria-hidden="true"
              >
                <i className={`${item.icon} text-base`} />
              </span>
              <div className="min-w-0">
                <dt className="font-num text-lg font-semibold leading-none text-foreground-950">{item.value}</dt>
                <dd className="mt-1 text-[11px] text-foreground-500">{item.label}</dd>
              </div>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}